import React, {useEffect} from 'react'
import { connect } from 'react-redux'
import { findRoutes, setLineNumber } from '../../actions/api'

import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';

import RouteViewer from '../viewers/route-viewer'
import {Box} from "@mui/material";
import ViewerContainer from "../viewers/viewer-container";
import i18n from "../../../i18nSetup";

function RouteSearchTab(props) {

    const {routeResults, locale, agencyFilter, line} = props;
    const [textFieldValue, setValue] = React.useState("");
    const [initScreen, setInitScreen] = React.useState(false);


    useEffect(() => {
        if (line) {
            if (!initScreen) {
                setValue(line);
                props.findRoutes(line, locale, agencyFilter);
                setInitScreen(true);
            }
        } else {
            setValue("")
            if(agencyFilter){
                props.findRoutes("all_routes", locale, agencyFilter);
            }
        }

    }, [line]);

    useEffect(() => {

        if(agencyFilter && !line){
            //console.log("agency filter changed:",agencyFilter);
            props.findRoutes("all_routes", locale, agencyFilter);
        }
        

    }, [agencyFilter]);

    const handleChangeText = (e)=> {
        setValue(e.target.value);
        if(e.target.value && e.target.value.trim()){
            findRoutesBySearch(e.target.value)
        }else{
            props.setLineNumber("")
        }
    }

    const keyPress = (e)=> {
        if(e.keyCode === 13){
            if(e.target.value && e.target.value.trim()){
                findRoutesBySearch(e.target.value.trim())
            }
        }
    }
    const findRoutesBySearch = (lineNumber)=> {
        props.findRoutes(lineNumber.trim(), locale, agencyFilter);
        props.setLineNumber(lineNumber)
    }
    return (
        <ViewerContainer>

    {(routeResults && agencyFilter) ? (<h3 style={{fontWeight:'bold',textAlign:'center'}}>{i18n.t("agencyRoutes") + routeResults[0].route.agency.name}</h3>) : null}   
            <Input value={textFieldValue} placeholder={i18n.t('enterLineNumber')} inputProps={{ 'aria-label': 'description'}}  fullWidth
                   startAdornment={
                <InputAdornment position="start">
                    <DirectionsBusIcon fontSize={"small"} />
                </InputAdornment>
            } onChange={handleChangeText} onKeyDown={keyPress}  />
            <Box id={'search-screen'}/>
            {
                (routeResults && (textFieldValue || agencyFilter)) ? (<Box mt={4}>

                   

                    <RouteViewer hideBackButton/>
                </Box>) : null
            }
        </ViewerContainer>
    )
}

const mapStateToProps = (state, ownProps) => {
    return {
        viewedRoute: state.otp.ui.viewedRoute,
        routes: state.otp.transitIndex.routes,
        routeResults: state.otp.transitIndex.routesArray,
        locale: state.otp.currentQuery.locale,
        agencyFilter:state.otp.currentQuery.agencyFilter,
        line: state.otp.transitIndex.line
    }
}

const mapDispatchToProps = {
    findRoutes,
    setLineNumber
}
export default connect(mapStateToProps, mapDispatchToProps)(RouteSearchTab)